import React, { useState } from 'react';
import { IconButton } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { Calendar } from './Calendar';

export function CarouselScheduling({
  selectedDate,
  setSelectedDate,
  weekDaysKey,
  setWeekDaysKey,
  filterDate,
}) {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setWeekDaysKey(weekDaysKey + 1);
  };

  const handleNextMonth = () =>
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1),
    );

  const handlePreviousMonth = () =>
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1),
    );

  const displayedMonths = [0, 1, 2, 3].map((monthOffset) => {
    const month = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + monthOffset,
    );
    return (
      <Calendar
        key={month.getTime()}
        onChange={handleDateChange}
        currentMonth={month}
        selectedDate={selectedDate}
        filterDate={filterDate}
      />
    );
  });

  return (
    <div className="carouselCalendar">
      <IconButton style={{ paddingLeft: '20px' }} onClick={handlePreviousMonth}>
        <ArrowBackIos
          className="personArrow"
          fontSize="large"
          color="primary"
        />
      </IconButton>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '30px',
        }}
      >
        {displayedMonths}
      </div>
      <IconButton onClick={handleNextMonth}>
        <ArrowForwardIos
          className="personArrow"
          fontSize="large"
          color="primary"
        />
      </IconButton>
    </div>
  );
}
